import { queryOptions } from '@tanstack/react-query';
import { getAdjusterPerformanceScoreFunction } from './getAdjusterPerformanceScoreQueryFunction';

export const getAdjusterPerformanceScoreQueryOptions = () => {
  return queryOptions({
    queryKey: ['AdjusterPerformanceScore'],
    queryFn: () => getAdjusterPerformanceScoreFunction(),
  });
};
